import React from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Table,
} from 'reactstrap';
import { KycConplianceList } from '../models/kycModel';

interface KycComplianceModalProps {
  isOpen: boolean;
  onClose: () => void;
  lists: KycConplianceList[];
}

const KycComplianceModal: React.FC<KycComplianceModalProps> = ({
  isOpen,
  onClose,
  lists,
}) => (
  <Modal isOpen={isOpen} toggle={onClose} centered size="md">
    <ModalHeader toggle={onClose}>Listas de Cumplimiento</ModalHeader>
    <ModalBody>
      <Table responsive>
        <thead>
          <tr>
            <th>Nombre</th>
            <th>Apellido</th>
            <th>Lista</th>
            <th>Coincidencia (%)</th>
          </tr>
        </thead>
        <tbody>
          {lists && lists.length > 0 ? (
            lists.map((item, idx) => (
              <tr key={idx}>
                <td>{item.first_name}</td>
                <td>{item.last_name}</td>
                <td>{item.list_name}</td>
                <td>{item.coincidence}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={4} className="text-center text-muted">
                No hay coincidencias en listas.
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </ModalBody>
    <ModalFooter>
      <Button color="secondary" onClick={onClose}>
        Cerrar
      </Button>
    </ModalFooter>
  </Modal>
);

export default KycComplianceModal;
